import { useCodeEditorSettings } from '@/modules/CodeEditor/CodeEditor.hooks.ts';

const EditorSettingsInit = () => {
    useCodeEditorSettings();
    return false;
};

export default EditorSettingsInit;
